<template>
  <div class="register_partner_page_wrap shop_page" >
    <img src="./img/2.png" class="logo_img" />
    <img src="./img/5.png" class="register_img" />
    <div class="title shop" >请填写相关资料，完成注册</div>
    <div class="form_wrap" >
      <div class="form_item" >
        <div class="form_item_label" >
          门店名称
        </div>
        <input class="form_input" placeholder="请输入门店名称" v-model="form.name" />
      </div>

      <div class="form_item" >
        <div class="form_item_label" >
          手机号
        </div>
        <input class="form_input" placeholder="请输入手机号" type="number" v-model="form.tel" />
      </div>

      <div class="form_item" >
        <div class="form_item_label" >
          密码
        </div>
        <input class="form_input" placeholder="请输入密码" type="password" v-model="form.password" />
      </div>

      <div class="form_item" @click.prevent="show = true" >
        <div class="form_item_label" >
          地址
        </div>
        <input class="form_input" placeholder="请选择" v-model="area" />
      </div>

      <div class="form_item">
        <div class="form_item_label" >
          详细地址
        </div>
        <input class="form_input" placeholder="请选择" v-model="form.address" />
      </div>

      <div class="form_item" >
        <div class="form_item_label" >
          店主姓名
        </div>
        <input class="form_input" placeholder="请输入店主姓名" v-model="form.trueName" />
      </div>

      <div class="form_item" >
        <div class="form_item_label" >
          身份证号
        </div>
        <input class="form_input" placeholder="请输入身份证号" v-model="form.idCardNo" />
      </div>

      <div class="upload_form_wrap" @click="uploadType = 'idCardHeadImgUrl'"  >
        <div class="form_item_label" >
          上传身份证照片
        </div>

        <van-uploader :before-read="beforeUpload">
          <div class="upload_content" v-if="!form.idCardHeadImgUrl" >
            <img src="./img/4.png" class="upload_img"  />
            <div class="upload_text" >上传身份证人像面</div>
          </div>
          <div class="upload_file_content" v-else >
            <img :src="form.idCardHeadImgUrl" />
          </div>
        </van-uploader>
      </div>

      <div class="upload_form_wrap" @click="uploadType = 'idCardCountryImgUrl'">
        <div class="form_item_label" >
          上传身份证照片
        </div>

        <van-uploader :before-read="beforeUpload">
          <div class="upload_content" v-if="!form.idCardCountryImgUrl" >
            <img src="./img/4.png" class="upload_img"  />
            <div class="upload_text" >上传身份证国徽面</div>
          </div>
          <div class="upload_file_content" v-else >
            <img :src="form.idCardCountryImgUrl" />
          </div>
        </van-uploader>
      </div>

      <div class="upload_form_wrap"  @click="uploadType = 'businessLicenseImgUrl'">
        <div class="form_item_label" >
          上传营业执照照片
        </div>

        <van-uploader :before-read="beforeUpload">
          <div class="upload_content" v-if="!form.businessLicenseImgUrl" >
            <img src="./img/4.png" class="upload_img"  />
            <div class="upload_text" >上传营业执照照片</div>
          </div>
          <div class="upload_file_content" v-else >
            <img :src="form.businessLicenseImgUrl" />
          </div>
        </van-uploader>
      </div>
    </div>
    <van-popup v-model="show" position="bottom">
<!--      <van-area title="所在地区" :area-list="areaList" @confirm="areaConfirm" @cancel="show = false" />-->
      <van-cascader
        title="请选择所在地区"
        :options="options"
        @close="show = false"
        @finish="onFinish"
        :field-names="{ 'text': 'name',  'value': 'cityId', 'children': 'sonList' }"
      />
    </van-popup>
    <van-button class="submit_button" @click="handleSubmit" :loading="submitting" >提交</van-button>
  </div>
</template>
<style scoped lang="less" >
@import "index";
</style>
<script>
import {
  shopAdd,
  getAllSystemCityVoTree
} from "@/api";
import { areaList } from '@vant/area-data';
import { Toast } from 'vant'
import wx from 'weixin-js-sdk'
export default {
  name: 'registerPartner',
  data() {
    return {
      form: {
        address: '',
        businessLicenseImgUrl: '',
        city: '',
        cityCode: '',
        county: '',
        countyCode: '',
        idCardCountryImgUrl: '',
        idCardHeadImgUrl: '',
        idCardNo: '',
        parentAgentId: this.$route.query.parentAgentId
      },
      show: false,
      area: '',
      areaList,
      uploadType: '',
      submitting: false,
      options: []
    }
  },
  methods: {
    onFinish(event) {
      let list = event.selectedOptions
      this.form.province = list[0].name
      this.form.city = list[1].name
      this.area = list[0].name + list[1].name
      this.form.provinceCode = list[0].cityId
      this.form.cityCode = list[1].cityId
      if(list.length > 2) {
        this.form.county = list[2].name
        this.form.countyCode = list[2].cityId
        this.area = list[0].name + list[1].name + list[2].name
      }
      this.show = false
    },
    handleSubmit() {
      const { form } = this
      if(!form.name) {
        Toast('请输入门店名称')
        return false
      }

      if(!form.tel) {
        Toast('请输入手机号')
        return false
      }

      if(!this.area) {
        Toast('请选择地址')
        return false
      }

      if(!form.address) {
        Toast('请输入详细地址')
        return false
      }

      if(!form.trueName) {
        Toast('请输入店主姓名')
        return false
      }

      if(!form.idCardNo) {
        Toast('请输入身份证号')
        return false
      }

      if(!form.idCardHeadImgUrl) {
        Toast('请上传身份证人像面')
        return false
      }

      if(!form.idCardCountryImgUrl) {
        Toast('请上传身份证国徽面')
        return false
      }

     /* if(!form.businessLicenseImgUrl) {
        Toast('请上传营业执照')
        return false
      }*/

      if(!this.isValidIDCard(form.idCardNo)) {
        Toast('身份证号不正确')
        return false
      }

      if(!this.isPhone(form.tel)) {
        Toast('手机号格式不正确')
        return false
      }

      this.submitting = true
      shopAdd({...form}).then(res => {
        this.submitting = false
        if(res.success) {
          this.$router.replace({
            name: 'success'
          })
        }else {
          Toast(res.msg)
        }
      })

    },
    isPhone(phone) {
      const reg = /^((\+|00)86)?1((3[\d])|(4[5,6,7,9])|(5[0-3,5-9])|(6[5-7])|(7[0-8])|(8[\d])|(9[1,8,9]))\d{8}$/;
      return reg.test(phone);
    },
    isValidIDCard(idCard) {
      // 身份证正则表达式
      var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      return reg.test(idCard);
    },
    beforeUpload(file) {
      this.$upload(file, url => {
        console.log(this.uploadType)
        this.form[this.uploadType] = url
      })
      return false
    },
    areaConfirm(event) {
      console.log(event)
      this.form.province = event[0].name
      this.form.city = event[1].name
      this.area = event[0].name + event[1].name + event[2].name
      this.form.provinceCode = event[0].code
      this.form.cityCode = event[1].code
      if(event.length > 2) {
        this.form.county = event[2].name
        this.form.countyCode = event[2].code
      }
      this.show = false
    },
    getAllSystemCityVoTree() {
      getAllSystemCityVoTree({}).then(res => {
        console.log(res)
        if(res.success) {
          this.options = this.optData(res.data)
        }
      })
    },
    optData(list) {
      list.map(item => {
        if(item.sonList.length > 0) {
          this.optData(item.sonList)
        }else {
          delete item['sonList']
        }
      })
      return list
    }
  },
  mounted() {
    this.getAllSystemCityVoTree()
  }
}
</script>
